import { z } from 'zod'

export const CRM_REMINDER_CONTRACT_VERSION = '1.0.0' as const

const rowSchema = z.record(z.unknown())
const optionalQueryString = z.preprocess(
  (value) => (typeof value === 'string' ? value : undefined),
  z.string().optional(),
)

export const crmReminderQuerySchema = z.object({
  orgId: optionalQueryString,
  org_id: optionalQueryString,
  limit: optionalQueryString,
  status: optionalQueryString,
  statusGroup: optionalQueryString,
  status_group: optionalQueryString,
  dueSoonHours: optionalQueryString,
  due_soon_hours: optionalQueryString,
  userId: optionalQueryString,
  user_id: optionalQueryString,
}).passthrough()

export const crmReminderResponseSchema = z.object({
  contract_version: z.literal(CRM_REMINDER_CONTRACT_VERSION),
  reminder: rowSchema,
  replayed: z.boolean().optional(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmReminderListResponseSchema = z.object({
  contract_version: z.literal(CRM_REMINDER_CONTRACT_VERSION),
  reminders: z.array(rowSchema),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export const crmReminderReadErrorEnvelopeSchema = z.object({
  contract_version: z.string().min(1),
  error: z.object({ code: z.string().min(1), message: z.string().min(1), reference: z.string().min(1) }).passthrough(),
}).passthrough()

export type CrmReminderQuery = z.infer<typeof crmReminderQuerySchema>
export type CrmReminderResponse = z.infer<typeof crmReminderResponseSchema>
export type CrmReminderListResponse = z.infer<typeof crmReminderListResponseSchema>
export type CrmReminderReadErrorEnvelope = z.infer<typeof crmReminderReadErrorEnvelopeSchema>
